module.exports = __webpack_public_path__ + "img/round-format_align_right-24px.8f642c57.svg";